
/*
	GUTENBERG JS - 2019-01-14
	This module needs to be recompiled or otherwise the store will not be avaiable.
	It's not clear why. More discovery is needed.
	However, this line replaces the previous code duplication.
*/
export * from '@wordpress/notices/src/store/actions?source=node_modules';
